export default "__VITE_ASSET__Dnz45slO__"